module.exports = __webpack_public_path__ + "media/app/assets/classes/evoker-8f6ff10d97e1cc05569d2e2ec2ec5d6d.jpg";